import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EmailBox from '../../../components/Enhanced/EmailBox';
import FortisButton from '../../../components/Basic/FortisButton';
import CheckBox from '../../../components/Basic/CheckBox';
import util from '../../../lib/util';
import { browserHistory } from 'react-router';


class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    props.initAPI();
    this.state = { isSubmitClicked: false };
  }
  componentWillReceiveProps(p) {
    if (p.forgotPasswordSuccess) {
      p.resetForgotPassword();
      p.resetForgotPasswordSuccess();
      browserHistory.push('/login');
    }
  }
  onSubmitClick = () => {
    const p = this.props;
    let validators = [
      ['email', p => p.email, 'Email address'],
      ['email', p => !p.email || util.isEmailValid(p.email), '#Email address is invalid'],
      ['forgotPasswordAgree', p => p.forgotPasswordAgree == 1, "#required"]
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        Email: p.email
      };
      p.forgotPassword(model);
      this.setState({ isSubmitClicked: true });
    }
  };
  render() {
    const p = this.props;

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="panel panel-default">
          <div className="panel-body">
            {
              !p.forgotPasswordSuccess && this.state.isSubmitClicked ?
                <div className="row animated-element animate-show" >
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-12">
                        <p>Sorry, we can't find the email address you have provided. You can talk to a customer service representatives to help you:</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <p><b>Natural gas customers</b><br />
                          Toll free: 1-888-224-2710<br />
                          Monday - Friday: 7 a.m. to 8 p.m</p>
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }
            <div className="row">
              <div className="col-md-12">
                <h3 className="panel-title text-primary" style={{ "font-size": "24px" }}> Forgot Password</h3> <br />
                <hr className="soften" />
                <p>Please enter the email address you used when setting up your profile.</p>
                <div>
                  <EmailBox id="email" name="email" title="Email address" required errorMsg="Email address is required" maxLength={241} />
                </div>
                <div className="form-group">
                  <CheckBox name="forgotPasswordAgree" required title="<b>	By entering and submitting my email address, I am consenting to receive electronic communications from FortisBC about my request.</b>" />
                </div>
                <div className="form-group">
                  <p> Note: you will receive an email with a link to click to reset your password.</p>
                </div>
                <div className="form-group">
                  <div className="row text-center">
                    <div className="col-lg-12" style={{ "display": "inline-flex" }}>
                      <FortisButton text="Submit" onClick={this.onSubmitClick}  />
                      <FortisButton text="Cancel" onClick={() => browserHistory.push('/login')}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  email: PropTypes.string,
  forgotPasswordAgree: PropTypes.int,
  forgotPasswordSuccess: PropTypes.bool,
  initAPI: PropTypes.func
};

function mapStateToProps(state) {
  return {
    form: state.form,
    email: state.form.email,
    forgotPasswordAgree: state.form.forgotPasswordAgree,
    forgotPasswordSuccess: state.gas.forgotPasswordSuccess
  };
}

function mapDispatchToProps(dispatch) {
  return {
    initAPI: () => {
      dispatch({ type: 'INITIALIZE_FORGOTPASSWORD' });
      dispatch({ type: 'INITIALIZE_API' });
    },
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    forgotPassword: (model) => dispatch({ type: 'FORGOT_PASSWORD', model }),
    resetForgotPassword: () => dispatch({ type: 'RESET_FORGOT_PASSWORD' }),
    resetForgotPasswordSuccess: () => dispatch({ type: 'FORGOT_PASSWORD_SUCCESS', forgotPasswordSuccess: false })

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

